export interface UpdateDatesActionPayload {
  departDate: string;
  returnDate?: string;
}
